import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, findCategory } from "@/lib/api";

export default function EssayDetail() {
    const { slug } = useParams();
    const [essay, setEssay] = useState(null);
    const [notFound, setNotFound] = useState(false);

    useEffect(() => {
        setNotFound(false);
        setEssay(null);
        api.get(`/essays/${slug}`)
            .then((r) => setEssay(r.data))
            .catch(() => setNotFound(true));
    }, [slug]);

    if (notFound) {
        return (
            <div className="pt-40 pb-24 text-center px-6">
                <p className="italic text-[rgb(var(--teal))] text-xl">This essay isn&apos;t published yet.</p>
                <Link to="/" className="btn-ghost mt-6 inline-flex">← Back home</Link>
            </div>
        );
    }
    if (!essay) return <div className="pt-40 text-center italic text-[rgb(var(--ink-2))]">Loading…</div>;

    const cat = findCategory(essay.category);
    const paragraphs = essay.content.split("\n\n");

    return (
        <div className="pt-32 md:pt-40 pb-16" data-testid={`essay-detail-${essay.slug}`}>
            <article className="mx-auto max-w-3xl px-6 md:px-10">
                <Link
                    to={`/${essay.category}`}
                    className="btn-text mb-8 inline-flex"
                    data-testid="essay-category-link"
                >
                    ← {cat?.label}
                </Link>

                <h1 className="text-3xl md:text-5xl font-bold text-[rgb(var(--teal))] tracking-tight leading-[1.1]">
                    {essay.title}
                </h1>
                {essay.subtitle && (
                    <p className="mt-4 text-lg md:text-xl italic text-[rgb(var(--orange))]">
                        {essay.subtitle}
                    </p>
                )}
                <div className="mt-6 flex items-center gap-3 text-xs text-[rgb(var(--ink-2))]/70">
                    <span className="overline text-[rgb(var(--gold))]">
                        {new Date(essay.created_at).toLocaleDateString("en-US", {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                        })}
                    </span>
                    <span>·</span>
                    <span>{essay.read_minutes} min read</span>
                </div>

                {essay.cover_image && (
                    <div className="frame aspect-[16/9] mt-10">
                        <img src={essay.cover_image} alt={essay.title} />
                    </div>
                )}

                <div className="mt-12 prose-editorial">
                    {paragraphs.map((p, i) => (
                        <p key={i}>{p}</p>
                    ))}
                </div>

                <div className="mt-16 pt-8 border-t hairline flex flex-wrap justify-between gap-6">
                    <p className="italic text-[rgb(var(--teal))]">— Leah</p>
                    <Link to={`/${essay.category}`} className="btn-text" data-testid="essay-back-link">
                        More from {cat?.short} →
                    </Link>
                </div>
            </article>
        </div>
    );
}
